import Actions from '../../odata/actions';

const actions = new Actions('csvOrderLine', 'csvOrderLines');

export default actions;
